module.exports = __webpack_public_path__ + "static/media/menstrual-cycle@2x.bb1ffcf6.png";